export default __webpack_public_path__ + "static/media/subscribe.cbbae060.svg";